import { useQuery } from '@apollo/client/react';
import { useParams } from 'react-router';

import { CLIP_ELIGIBILITY } from 'queries/clip';

/**
 * @description
 * @returns {Object} - The result of the clipEligibilityCriteria query
 */
const useClipEligibility = () => {
  const { accountId, customerId } = useParams();

  return useQuery(CLIP_ELIGIBILITY, {
    skip: !customerId || !accountId,
    variables: { customerId, accountId },
  });
};

export default useClipEligibility;
